import React from "react";

export const DataNotFound = React.forwardRef(({ message }, ref) => {
  return (
    <div className={"info-box"}>
      <p>{message || "Data Not Found"}</p>
    </div>
  );
});
